"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));

var _colors = require("@mui/material/colors");

var _excluded = ["deletable"];

var DeleteButton = function DeleteButton(_ref) {
  var deletable = _ref.deletable,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  if (deletable === false) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({}, props, {
    alt: "Remove Item from Cart",
    title: "Remove Item from Cart",
    size: "large"
  }), /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
    style: {
      color: _colors.red[500]
    }
  }));
};

var _default = DeleteButton;
exports["default"] = _default;